import { cn } from "./cn";

/** Port of the reference's RoleBadge (src/components/ui/RoleBadge.tsx). No
 * test in the reference — RoleBadge.test.tsx below is authored, not ported. */
const ROLE_CONFIG: Record<string, { bg: string; text: string; dot: string }> = {
  platform_admin: { bg: "bg-purple-100", text: "text-purple-700", dot: "bg-purple-500" },
  power_user: { bg: "bg-accent/10", text: "text-accent", dot: "bg-accent" },
  org_admin: { bg: "bg-teal-100", text: "text-teal-700", dot: "bg-teal-500" },
  user: { bg: "bg-green-100", text: "text-green-700", dot: "bg-green-500" },
};

const FALLBACK = { bg: "bg-elevated", text: "text-ink-light", dot: "bg-ink-faint" };

function formatLabel(role: string): string {
  const spaced = role.replace(/_/g, " ");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

interface RoleBadgeProps {
  role: string;
  className?: string;
}

export function RoleBadge({ role, className }: RoleBadgeProps) {
  const config = ROLE_CONFIG[role] ?? FALLBACK;

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium",
        config.bg,
        config.text,
        className,
      )}
    >
      <span className={cn("mr-1.5 h-1.5 w-1.5 rounded-full", config.dot)} aria-hidden="true" />
      {formatLabel(role)}
    </span>
  );
}
